<script lang="ts">
  import Teaser from "./pages/Teaser.svelte";
  import Landing from "./pages/Landing.svelte";
  import Success from "./pages/Success.svelte";
  import Rules from "./pages/Rules.svelte";
  import Ended from "./pages/Ended.svelte";
  import { onMount } from "svelte";
  import Fooji from "@fooji/microsites";
  import { configStore, type Config } from "./stores/campaign";
  import ErrorDuplicate from "./pages/ErrorDuplicate.svelte";
  import Error from "./pages/Error.svelte";
  import Loading from "./pages/Loading.svelte";
  import Logo from "./assets/images/logo.svg";
  import { get } from "svelte/store";
  import { addressStore, type PersistedAddress } from "./stores/address";
  import FoojiLogo from "./assets/images/fooji.svg";
  import { modeStore } from "./stores/mode";

  let page: string = "loading";
  let status: string;

  let isLoading: boolean = true;
  let loadingTitle: string | undefined = "Getting ready...";

  const query = new URLSearchParams(document.location.search);

  if (query.has("demo")) {
    modeStore.set("demo");
  }

  const getConfigAndCheckStatus = async () => {
    try {
      const config = (await Fooji.Config.get()) as Config;
      status = await Fooji.Campaign.getStatus(config.campaign);
      configStore.set(config);
    } catch (error) {
      console.error("Setup error:", error);
      page = "campaign-over";
    }
  };

  const fetchSetupData = async () => {
    isLoading = true;

    const config = await getConfigAndCheckStatus();
    console.log("Config", $configStore);

    if (status === "over" || !$configStore?.campaign) {
      console.log("Status over. Setting page to campaign-over");
      page = "campaign-over";
    } else if (status === "teasing") {
      console.log("Status over. Setting page to campaign-teaser");
      page = "campaign-teaser";
    } else {
      await Fooji.Auth.anonymous.start($configStore.campaign);
      console.log("Anonymous auth started");
      const currentCampaignUser = await Fooji.CampaignUser.get();
      console.log("Current campaign user", currentCampaignUser);

      const phase = Object.keys(currentCampaignUser.metadata ?? {})
        .filter((k) => k.startsWith("current_phase_"))
        .sort()
        .reverse()[0];
      if (
        currentCampaignUser?.metadata[phase] === "thank-you" ||
        currentCampaignUser?.metadata[phase] === "lucky-dip-phase"
      ) {
        page = "error-duplicate";
      } else {
        page = "landing";
      }
    }

    isLoading = false;
  };

  onMount(() => {
    fetchSetupData();
  });

  async function onFormComplete() {
    await enter(true);
  }

  async function enter(firstAttempt: boolean) {
    loadingTitle = undefined;
    isLoading = true;
    const selectedAddress = get(addressStore) as PersistedAddress;

    const { currentPhase, campaignUser } = await Fooji.Campaign.enter(
      selectedAddress.id
    );

    if (
      currentPhase.startsWith("thank-you") ||
      currentPhase.startsWith("lucky-dip-phase")
    ) {
      isLoading = false;
      page = "success";
    }

    if (currentPhase.startsWith("complete-order") && firstAttempt) {
      return enter(false);
    }

    if (currentPhase.startsWith("duplicate-order")) {
      isLoading = false;
      page = "error-duplicate";
    }

    isLoading = false;
  }

  function goToRules() {
    history.replaceState({}, "", "/rules");
    page = "rules";
  }
</script>

<!-- Header -->
<header class="flex justify-center items-center py-7 lg:py-8">
  <a href="/">
    <img src={Logo} alt="logo" class="w-44 md:w-64" />
  </a>
</header>
<!-- END header -->

<div class="flex justify-center">
{#if isLoading}
  <Loading title={loadingTitle}></Loading>
{:else if page === "campaign-teaser"}
  <Teaser />
{:else if page === "landing"}
  <Landing {onFormComplete} />
{:else if page === "campaign-over"}
  <Ended />
{:else if page === "error-duplicate"}
  <ErrorDuplicate />
{:else if page === "error"}
  <Error />
{:else if page === "success"}
  <Success />
{:else if page === "rules"}
  <Rules />
{/if}
</div>

<!-- Footer -->
<footer class="py-10 border-t border-my-light-gray">
  <div class="container-center">
    <div
      class="flex justify-between sm:flex-row flex-col items-center w-full gap-10"
    >
      <div>
        <p class="text-xs font-normal mb-2">powered by</p>
        <img src={FoojiLogo} alt="fooji" />
      </div>
      <ul class="flex items-center gap-5 sm:gap-6">
        <li>
          <a
            href="#"
            on:click={goToRules}
            class="text-sm font-normal underline decoration-solid capitalize animate hover:opacity-80"
            >Official Rules</a
          >
        </li>
        <li>
          <a
            href="https://fooji.com/company/terms-of-service"
            class="text-sm font-normal underline decoration-solid capitalize animate hover:opacity-80"
            >Terms</a
          >
        </li>
        <li>
          <a
            href="https://fooji.com/company/privacy-policy"
            class="text-sm font-normal underline decoration-solid capitalize animate hover:opacity-80"
            >Privacy</a
          >
        </li>
        <li>
          <a
            href="https://3719b8e5-bbb2-48ec-b39b-d4eb747db867.prod12-care.sprinklr.com/"
            class="text-sm font-normal underline decoration-solid capitalize animate hover:opacity-80"
            >Need Help?</a
          >
        </li>
      </ul>
    </div>
  </div>
</footer>

<!-- END footer -->

<style>
</style>
